import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import '../../css/StartPage.css'

const Faq = () => {
	const { t } = useTranslation('startPage')
	const [isOpen, setIsOpen] = useState(false)
	const [openIndex, setOpenIndex] = useState(null)

	const faqItems = t('faq.items', { returnObjects: true })

	const toggle = index => {
		setOpenIndex(prev => (prev === index ? null : index))
	}

	return (
		<section className='faq-section'>
			<button
				className='about-toggle'
				onClick={() => setIsOpen(prev => !prev)}
				aria-expanded={isOpen}
			>
				<span>{t('faq.title')}</span>
				<ChevronDown size={18} className={`about-chevron ${isOpen ? 'open' : ''}`} />
			</button>

			{isOpen && (
				<div className='faq-list mt-20'>
					{faqItems.map((item, index) => {
						const isItemOpen = openIndex === index

						return (
							<div key={index} className={`faq-item ${isItemOpen ? 'open' : ''}`}>
								<button
									className='faq-question'
									onClick={() => toggle(index)}
									aria-expanded={isItemOpen}
								>
									<span>{item.question}</span>
									<ChevronDown size={18} className={`faq-chevron ${isItemOpen ? 'open' : ''}`} />
								</button>

								{isItemOpen && <div className='faq-answer-inner'>{item.answer}</div>}
							</div>
						)
					})}
				</div>
			)}
		</section>
	)
}

export default Faq
